import { makeStyles } from '@material-ui/core/styles'
import React, { useMemo } from 'react'
import {
  Datagrid,
  DateField,
  Filter,
  List,
  ReactAdminComponentProps,
  TextField,
  TextInput,
  UrlField,
} from 'react-admin'
import { modelStyles } from '../../../helpers/model-styles'
import {
  DefaultDeleteButton,
  DefaultEditButton,
  DefaultShowButton,
} from '../../common/default-buttons'
import EmptyPage from '../../common/empty-page'
import Pagination from '../../common/pagination'
import { StatusField } from '../../common/status-field'
import { ToolbarCreateButton, TopToolbar } from '../../common/toolbar'
import { useDomain } from '../../contexts/domain-context'
import { useIsAtLeastDomainRole } from '../../hook/use-is-at-least-domain-role'

const useStyles = makeStyles(modelStyles)

const UsefulLinkListFilter = (props: unknown) => {
  const classes = useStyles()
  return (
    <Filter {...props} classes={{ form: classes.filter }} variant="outlined">
      <TextInput source="q" alwaysOn />
    </Filter>
  )
}

export const UsefulLinkList = ({ basePath }: ReactAdminComponentProps) => {
  const classes = useStyles()

  const domain = useDomain()
  const domainId = domain?.id
  const filter = useMemo(() => ({ domain: domainId }), [domainId])
  if (!useIsAtLeastDomainRole() || !domain) {
    return null
  }
  const actions = <Actions basePath={basePath} />

  return (
    <List
      basePath={basePath}
      bulkActionButtons={false}
      filters={<UsefulLinkListFilter />}
      pagination={<Pagination />}
      empty={<EmptyPage actions={actions} />}
      filter={filter}
      sort={{ field: 'createdAt', order: 'DESC' }}
      classes={{ content: classes.content }}
      actions={actions}
    >
      <Datagrid className={classes.list}>
        <TextField source="name" />
        <TextField source="urlText" />
        <UrlField source="url" />
        <StatusField source="disabled" labelIfFalse="" />
        <DateField source="createdAt" />
        <DefaultShowButton />
        <DefaultEditButton />
        <DefaultDeleteButton />
      </Datagrid>
    </List>
  )
}

const Actions = ({ basePath }: ReactAdminComponentProps) => {
  return (
    <TopToolbar>
      <ToolbarCreateButton basePath={basePath} />
    </TopToolbar>
  )
}
